/**
 * App Providers
 * ผู้ให้บริการแอป
 *
 * Wraps the app with all required context providers.
 * ครอบแอปด้วย context providers ที่จำเป็นทั้งหมด
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import { AuthProvider } from '@/features/auth/AuthProvider'
import type { ReactNode } from 'react'

// Initialize i18n (must be imported before components that use it)
import '@/lib/i18n'

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  )
}
